export default "<router-outlet></router-outlet>\r\n<toaster-container></toaster-container>\r\n";